import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_10 = { class: "io-calculator__usage-field__popover__slider" }

import {
  computed,
  ref,
  onBeforeMount,
  watch,
  nextTick,
} from 'vue';

import InputField from '@/components/InputField.vue';
import IoSlider from '@/components/inputs/Slider.vue';
import ClickWrapper from '@/components/ClickWrapper.vue';
import IconPower1 from '@/components/icons/IconPower1.vue';
import IconPower2 from '@/components/icons/IconPower2.vue';
import IconPower3 from '@/components/icons/IconPower3.vue';
import IconPower4 from '@/components/icons/IconPower4.vue';
import IconGas1 from '@/components/icons/IconGas1.vue';
import IconGas2 from '@/components/icons/IconGas2.vue';
import IconGas3 from '@/components/icons/IconGas3.vue';
import IconGas4 from '@/components/icons/IconGas4.vue';
import { env, formatNumber } from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCalculatorUsageField',
  props: /*#__PURE__*/_mergeModels({
    label: {},
    noInitialValue: { type: Boolean },
    showValidCheck: { type: Boolean },
    branch: { default: 'power' },
    isValid: { type: Boolean },
    validColor: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels([
  'keyup',
  'input',
], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const modelValue = _useModel(__props, "modelValue");
const props = __props;

const emit = __emit;

const root = ref<InstanceType<typeof ClickWrapper>>();
const popover = ref<InstanceType<typeof HTMLElement>>();
const iconRow = ref<InstanceType<typeof HTMLElement>>();
const iconRowWrapper = ref<InstanceType<typeof HTMLElement>>();

const percentage = ref(25);
const isOpen = ref(false);
const selectedIcon = ref(1);

const cssVars = computed(() => {
  let iconColorActive = Array.isArray(props.validColor) ? props.validColor[0] : 'var(--color-brand-primary)';
  if (!iconColorActive) {
    iconColorActive = 'var(--color-brand-primary)';
  }

  return {
    '--icon-color-active': iconColorActive,
  };
});

const iconColor = computed(() => [
  selectedIcon.value === 1 ? 'var(--icon-color-active)' : '#DBDBDB',
  selectedIcon.value === 2 ? 'var(--icon-color-active)' : '#DBDBDB',
  selectedIcon.value === 3 ? 'var(--icon-color-active)' : '#DBDBDB',
  selectedIcon.value === 4 ? 'var(--icon-color-active)' : '#DBDBDB',
]);

const onKeyUp = (e: unknown) => {
  emit('keyup', e);
};

const preselectIcons = computed(() => [
  props.branch === 'gas' ? IconGas1 : IconPower1,
  props.branch === 'gas' ? IconGas2 : IconPower2,
  props.branch === 'gas' ? IconGas3 : IconPower3,
  props.branch === 'gas' ? IconGas4 : IconPower4,
]);

const preSelectValues = computed(() => {
  switch (props.branch) {
    case 'gas':
      return [
        5000,
        12000,
        18000,
        20000,
      ];
    default:
      return [
        1200,
        2000,
        3000,
        4250,
      ];
  }
});

const maxUsage = computed(() => {
  switch (props.branch) {
    case 'gas':
      return env('CALCULATOR_MAX_USAGE_GAS', 50000) as number;
    default:
      return env('CALCULATOR_MAX_USAGE_POWER', 10000) as number;
  }
});

const minUsage = computed(() => {
  switch (props.branch) {
    case 'gas':
      return env('CALCULATOR_MIN_USAGE_GAS', 600) as number;
    default:
      return env('CALCULATOR_MIN_USAGE_POWER', 100) as number;
  }
});

const sliderSteps = computed(() => {
  const steps = [];

  const pv = preSelectValues.value;
  const maxu = maxUsage.value;
  const minu = minUsage.value;

  const stepSize = maxu / (pv.length + 1);
  // eslint-disable-next-line no-bitwise
  for (let i = 0; i < (pv.length + 1); i += 1) {
    const stepMin = pv[i - 1] || minu;
    const stepMax = pv[i] ? (pv[i] - 1) : maxu;

    steps.push({
      size: stepSize,
      range: stepMax - stepMin,
      min: stepMin,
      max: stepMax,
      percentage: ((stepSize / maxu) * i * 100),
    });
  }

  return steps;
});

const getCurrentStepByPercentage = (pc: number) => {
  const pv = preSelectValues.value;
  const mu = maxUsage.value;

  const stepSize = mu / (pv.length + 1);
  // eslint-disable-next-line no-bitwise
  let currentStep = ~~(pc / stepSize);
  if (currentStep > (sliderSteps.value.length - 1)) {
    currentStep = sliderSteps.value.length - 1;
  }
  const step = sliderSteps.value[currentStep];
  const stepPercentage = (pc - (currentStep * step.size)) / step.size;

  return {
    num: currentStep,
    size: step.size,
    min: step.min,
    max: step.max,
    percentage: stepPercentage,
  };
};

const getPercentageByValue = (v: number) => {
  const cstep = sliderSteps.value.filter((s) => s.min <= v && s.max >= v)[0];

  if (cstep) {
    const cstepPercentage = (v - cstep.min) / cstep.range;
    const cp = (cstepPercentage * ((cstep.size / maxUsage.value) * 100)) + cstep.percentage;

    return (cp / 100) * maxUsage.value;
  }

  return 0;
};

const calculateValueByPercentage = (percent: number) => {
  const step = getCurrentStepByPercentage(percent);

  selectedIcon.value = step.num;

  return Math.ceil(step.min + ((step.max - step.min) * step.percentage));
};

const sliderDragValue = ref(preSelectValues.value[0]);

const value = computed({
  get(): unknown {
    return modelValue.value;
  },
  set(newValue: unknown): void {
    sliderDragValue.value = getPercentageByValue(newValue as number);
    modelValue.value = newValue;
  },
});

const onClickIcon = (iconInx: number) => {
  value.value = preSelectValues.value[iconInx];

  if (/Android|Mobi|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isOpen.value = false;
  }
};

onBeforeMount(() => {
  if (value.value) {
    // eslint-disable-next-line prefer-destructuring
    const val = value.value as number;
    if (!value.value || val < minUsage.value || val > maxUsage.value) {
      // eslint-disable-next-line prefer-destructuring
      value.value = preSelectValues.value[0];
    }
  } else if (!props.noInitialValue) {
    // eslint-disable-next-line prefer-destructuring
    value.value = preSelectValues.value[0];
  }

  percentage.value = getPercentageByValue((value.value || 0) as number);
  sliderDragValue.value = percentage.value;
});

const updateSliderValue = (val: number) => {
  value.value = calculateValueByPercentage(val);
};

const formatTooltip = (v: number) => `${formatNumber(calculateValueByPercentage(v), 0)} kWh`;

watch(() => isOpen.value, () => {
  if (isOpen.value) {
    nextTick(() => {
      if (root.value && popover.value) {
        popover.value.style.minWidth = '';
        popover.value.style.position = 'fixed';
        popover.value.style.position = 'absolute';
        popover.value.style.minWidth = 'calc(100% + 2em)';
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ClickWrapper, {
    ref_key: "root",
    ref: root,
    class: _normalizeClass(["io-calculator__usage-field", { 'open': isOpen.value }]),
    style: _normalizeStyle(cssVars.value),
    onOutside: _cache[7] || (_cache[7] = ($event: any) => (isOpen.value = false))
  }, {
    default: _withCtx(() => [
      _createVNode(InputField, {
        label: _ctx.label,
        type: "number",
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        min: minUsage.value,
        max: maxUsage.value,
        "only-numeric": true,
        showValidCheck: _ctx.showValidCheck,
        "is-valid": _ctx.isValid,
        "valid-color": _ctx.validColor,
        onFocusin: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = true)),
        onKeyup: onKeyUp
      }, null, 8, ["label", "modelValue", "min", "max", "showValidCheck", "is-valid", "valid-color"]),
      _withDirectives(_createElementVNode("div", {
        class: "io-calculator__usage-field__popover",
        ref_key: "popover",
        ref: popover
      }, [
        _createElementVNode("div", {
          class: "io-calculator__usage-field__popover__icons",
          ref_key: "iconRowWrapper",
          ref: iconRowWrapper
        }, [
          _createElementVNode("div", {
            class: "row g-2",
            ref_key: "iconRow",
            ref: iconRow
          }, [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(preselectIcons.value[0]), {
                color: iconColor.value[0],
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onClickIcon(0)))
              }, null, 8, ["color"]))
            ]),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(preselectIcons.value[1]), {
                color: iconColor.value[1],
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickIcon(1)))
              }, null, 8, ["color"]))
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(preselectIcons.value[2]), {
                color: iconColor.value[2],
                onClick: _cache[4] || (_cache[4] = ($event: any) => (onClickIcon(2)))
              }, null, 8, ["color"]))
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(preselectIcons.value[3]), {
                color: iconColor.value[3],
                onClick: _cache[5] || (_cache[5] = ($event: any) => (onClickIcon(3)))
              }, null, 8, ["color"]))
            ]),
            _hoisted_9
          ], 512)
        ], 512),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(IoSlider, {
            onChange: updateSliderValue,
            modelValue: sliderDragValue.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((sliderDragValue).value = $event)),
            max: maxUsage.value,
            step: 1,
            tooltip: true,
            "tooltip-show": "drag",
            "tooltip-format": formatTooltip
          }, null, 8, ["modelValue", "max"])
        ])
      ], 512), [
        [_vShow, isOpen.value]
      ])
    ]),
    _: 1
  }, 8, ["class", "style"]))
}
}

})